export type keyValue = string | number;
export type keyLabel = {
  key: keyValue;
  label: string;
};
export type datapoint = {
  key: keyValue;
  value: number;
};
export type seriesType = 'line' | 'area' | 'column' | 'column-stacked' | 'column-overlapped';
export type seriesBase<TType> = {
  type: TType;
  name: string;
  color: string;
  data: datapoint[];
  yTarget?: yTarget;
  showPointLabels?: boolean;
};
export type seriesLine = seriesBase<'line'> & {
  curved?: boolean;
  strokeDashed?: boolean;
  strokeWidth?: number;
};
export type seriesArea = seriesBase<'area'> & {
  curved?: boolean;
  strokeDashed?: boolean;
  strokeWidth?: number;
};
export type seriesColumn = seriesBase<'column'>;
export type seriesColumnStacked = seriesBase<'column-stacked'>;
export type seriesColumnOverlapped = seriesBase<'column-overlapped'>;
export type series = seriesLine | seriesArea | seriesColumn | seriesColumnStacked | seriesColumnOverlapped;
export type bounds = {
  top: number;
  bottom: number;
  left: number;
  right: number;
};
export type size = {
  width: number;
  height: number;
};
export type margin = {
  top: number;
  bottom: number;
  left: number;
  right: number;
};
export type yTarget = 'left' | 'right';
export type keyRotation = 0 | 45 | 90;
export type yAxisRange = {
  min?: number;
  max?: number;
};
export const seriesRenderOrder: seriesType[] = ['column', 'column-stacked', 'column-overlapped', 'area', 'line'] as const;
export type highlightState = 'none' | 'active' | 'inactive';
export type highlightStateProvider = (seriesName: string) => highlightState;
export type highlightYTargetStateProvider = (yTarget: yTarget) => highlightState;
export type OneUxPlotChartTypographyToken = 'label-100' | 'label-300' | 'mono-300';